// extracted by mini-css-extract-plugin
module.exports = {"root":"FactsComparisonCard_root__32A2F","title":"FactsComparisonCard_title__3_Qfe","chart":"FactsComparisonCard_chart__2cPzZ"};